// extracted by mini-css-extract-plugin
export default {"header":"HdcOzTCtHerBg0n7W56y","content":"aAITTQKlYO0S9bbC_nYi","placeHolderShimmer":"Df3TyjcPMtbnh3CJFSXa"};